import { render, staticRenderFns } from "./view.vue?vue&type=template&id=76b0fe4c&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=76b0fe4c&prod&scoped=true&lang=css"
import style1 from "./view.vue?vue&type=style&index=1&id=76b0fe4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b0fe4c",
  null
  
)

export default component.exports